import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { HudStatBar } from "../generic/hud-stat-bar/HudStatBar";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var Happiness = function (happinessInfo) {
    var totalHappiness = happinessInfo.happiness + (happinessInfo.happinessBuff || 0);
    var icon = totalHappiness >= 0 ? IdIcon.HappinessPositiveIcn : IdIcon.HappinessNegativeIcn;
    var fillClass = totalHappiness >= 0 ? IdStyles.hudHappinessPositiveFill : IdStyles.hudHappinessNegativeFill;
    var getHappiness = function () {
        if (happinessInfo.happinessBuff) {
            return (React.createElement("div", { className: "pl__medium" },
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: happinessInfo.happiness }),
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, format: TypeNumberFormat.Add, amount: happinessInfo.happinessBuff })));
        }
        return (React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: totalHappiness }));
    };
    return (React.createElement(HudStatBar, { icon: "" + icon, styleId: IdStyles.IconMedium, backgroundSize: "small", backgroundClassName: IdStyles.HudStat, className: "hud-stat-bar", fillClass: fillClass }, getHappiness()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/happiness/Happiness.tsx
// module id = 886
// module chunks = 3